import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { RecommendationContainer } from '../index.styled'
import IogoIcon01 from '../../../asserts/icon/client/physical-assessment/apple-logo.png'
import IogoIcon02 from '../../../asserts/icon/client/physical-assessment/ic_recommendation_logo_02.png'
import EditableText from '../components/EditableText'
import { ReactComponent as ExerciseIcon } from '../../../asserts/icon/client/physical-assessment/ic_exercise.svg'
import { ReactComponent as NutritionIcon } from '../../../asserts/icon/client/physical-assessment/ic_nutrition.svg'
import { ReactComponent as RejuvenationIcon } from '../../../asserts/icon/client/physical-assessment/ic_rejuvenation.svg'
import { FormFields } from '../components/ReferralEditor/index'
import StepItem from '../components/StepItem'
import HighestPriorityItem from '../components/HighestPriorityItem'
import EditButton from '../components/EditButton'
import { find, isArray, some } from 'lodash'
import { ReactComponent as LinkIcon} from '../../../asserts/icon/client/physical-assessment/ic_link.svg'
import './Resources.css'
import { Button, Modal, message } from 'antd'
import { ViewIcon } from '../../../components/assessmentReview/comp/hideWrap'
import { PlusOutlined } from '@ant-design/icons'
import ReferralItem from '../components/ReferralItem'
import ResourceSection from './ResourceSection'
import _ from 'lodash'
import ExerciseScheduler from './ExerciseRecommendationComp/RecommendModal';
import styled from 'styled-components'
import HideWrap from '../../../components/assessmentReview/comp/hideWrap'
import {
  XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, BarChart, Bar
} from 'recharts';
import { RecommendationColors } from '../../../utils';

const RecommendationFields = {
  GOALS: 'recommendation_goals',
  LIFESTYLE: 'recommendation_lifestyle',
  HEALTHSPAN_DOMAIN: 'recommendation_healthspan_domain',
  INTEGRATED_RECOMMENDATION: 'recommendation_integrated_recommendation',
  PROGRESSION: 'recommendation_progression',
  HOLISTIC_RECS: 'intro',
  REFERRALS: 'recommendation_referrals',
  WHAT_TO_EXPECT: 'expectations',
  NEXT_STEPS: 'support'
}

const {
  GOALS,
  LIFESTYLE,
  HEALTHSPAN_DOMAIN,
  INTEGRATED_RECOMMENDATION,
  PROGRESSION,
  HOLISTIC_RECS,
  WHAT_TO_EXPECT,
  NEXT_STEPS
} = RecommendationFields

const HighestPrioritiesConfigs = [
  {
    field: GOALS,
    title: 'Goals',
    placeholder: 'Please enter goals'
  },
  {
    field: LIFESTYLE,
    title: 'Lifestyle',
    placeholder: 'Please enter lifestyle'
  },
  {
    field: HEALTHSPAN_DOMAIN,
    title: 'Healthspan Domains',
    placeholder: 'Please enter healthspan domains'
  }
]

const {emerald, green, blue, teal, purple, indigo} = RecommendationColors

const StepsConfigs = [
  {
    field: PROGRESSION,
    title: 'Progression',
    placeholder: 'Light, Moderate, Light, Moderate, Moderate, Vigorous',
    icon: <ExerciseIcon />,
    color: 'rgb(255, 107, 0)'
  },
  {
    field: HOLISTIC_RECS,
    title: 'Holistic Recommendations',
    placeholder: 'Please enter holistic recommendations',
    icon: <ExerciseIcon />,
    color: 'rgb(255, 107, 0)'
  }
]

const expectationAndNextStepsConfigs = [
  {
    field: WHAT_TO_EXPECT,
    title: 'What to Expect',
    placeholder: 'Please enter what to expect',
    icon: <ExerciseIcon />,
    color: 'rgb(255, 107, 0)'
  },
  {
    field: NEXT_STEPS,
    title: 'Next Steps',
    placeholder: 'Please enter next steps',
    icon: <NutritionIcon />,
    color: 'rgb(123, 173, 45)'
  }
]

// Add these styled components after the existing styled components
const ExerciseGridContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.showHsdChart ? '33% 67%' : 'minmax(40px, 5%) 95%'};
  gap: 8px;
  width: 100%;
  height: 600px;
  padding-top: 10px;
  box-sizing: border-box;
  overflow: hidden;
`;

const ChartContainer = styled.div`
  height: 100%;
  width: 100%;
  background: transparent;
  border-radius: 20px;
  position: relative;
  min-width: 40px;
  overflow: hidden;
  display: flex;
  align-items: stretch;

  & > div {
    width: 100% !important;
    height: 100% !important;
  }
`;


const SchedulesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  width: 90%;
  overflow: hidden;
  padding: 8px;
  padding-top: 32px;
`;

// Helper function to render the weekly schedule
const renderWeeklySchedule = (weeklySchedule, intensity) => {
  if (!weeklySchedule || !weeklySchedule[intensity]) return null;

  const colorMap = {
    light: emerald,
    moderate: teal,
    vigorous: indigo
  };

  const titleMap = {
    light: 'Light Week Program',
    moderate: 'Moderate Week Program',
    vigorous: 'Vigorous Week Program'
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <h4 style={{ 
        color: colorMap[intensity],
        margin: '0 0 8px 0',
        fontSize: '16px',
        fontWeight: 'bold'
      }}>
        {titleMap[intensity]}
      </h4>
      <div className="weekly-schedule" style={{ 
        flex: 1,
        width: '100%',
        border: `1px solid ${colorMap[intensity]}`,
        borderRadius: '8px',
        padding: '1px',
        overflow: 'auto',
        boxSizing: 'border-box'
      }}>
        <div className="schedule-grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(7, minmax(min-content, 1fr))',
          gap: '1px',
          fontSize: '12px',
          width: '100%',
          minWidth: 0,
          overflow: 'hidden'
        }}>
          {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map(day => (
            <div key={day} className="day-column" style={{ 
              textAlign: 'center',
              minWidth: 0,
              overflow: 'hidden',
              padding: '0 1px'
            }}>
              <div className="day-header" style={{ 
                fontWeight: 'bold', 
                marginBottom: '1px',
                color: colorMap[intensity],
                fontSize: '12px'
              }}>
                {day.charAt(0).toUpperCase() + day.slice(1, 3)}
              </div>
              {weeklySchedule[intensity][day].map((activity, idx) => (
                <div 
                  key={`${activity.name}-${idx}`} 
                  className="activity-item" 
                  style={{
                    padding: '1px 2px',
                    marginBottom: '1px',
                    backgroundColor: colorMap[intensity],
                    color: 'white',
                    border: `1px solid ${colorMap[intensity]}`,
                    borderRadius: '5px',
                    fontSize: '12px',
                    wordBreak: 'break-word',
                    width: 'auto',
                    maxWidth: '100%'
                  }}
                >
                  <div style={{ fontWeight: 'bold' }}>{activity.name}</div>
                  <div>{activity.time}min</div>
                  {activity.rpe && <div>RPE: {activity.rpe}</div>}
                  {activity.heartRateZone && <div>HRZ: {activity.heartRateZone}</div>}
                  {activity.difficultyLevel && <div>{activity.difficultyLevel}</div>}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};


// 1. Banner Section
const BannerSection = () => {
  return (
    <div className="banner-section">
      <div className="logos-wrapper">
        <img src={IogoIcon01} alt="logo01" />
        <img src={IogoIcon02} alt="logo02" />
      </div>
      <div className="title">Recommendations and Next Steps</div>
    </div>
  )
}

// 2. Highest Priorities Section
const HighestPrioritiesSection = ({ editabled, data, onChange }) => {
  return (
    <div className="highest-priorities-section">
      <div className="subtitle">Priorities</div>
      <div className="items-section">
        {HighestPrioritiesConfigs.map((item, index) => (
          <HighestPriorityItem
            key={index}
            {...item}
            editabled={editabled}
            value={data[item.field]}
            onChange={onChange}
          />
        ))}
      </div>
    </div>
  )
}

// 3. Integrated Recommendation Section
const IRSection = ({ editabled, data, onChange }) => {
  const [editing, setEditing] = useState(false)
  return (
    <div className="ir-section">
      <EditableText
        className="editor-section"
        value={data}
        editing={editing}
        placeholder={editabled ? 'Please enter integrated recommendation' : ''}
        setEditing={setEditing}
        onSave={(text) => onChange(text, INTEGRATED_RECOMMENDATION)}
      />
      {!editing && editabled && <EditButton onClick={() => setEditing(true)} />}
    </div>
  )
}

// 4. Exercise, Nutrition, Rejuvenation
const StepsSection = ({ editabled, data, onChange }) => {
  return (
    <div className="step-section">
      <div className="subtitle">Recommendations</div>
      {StepsConfigs.map((item, index) => (
        <StepItem
          key={index}
          {...item}
          editabled={editabled}
          value={data[item.field]}
          onChange={onChange}
        />
      ))}
    </div>
  )
}

const ExpectationAndNextSteps = ({ editabled, data, onChange }) => {
  return (
    <div className="step-section">
      <div className="subtitle">Expectation And Next Steps</div>
      {expectationAndNextStepsConfigs.map((item, index) => (
        <StepItem
          key={index}
          {...item}
          editabled={editabled}
          value={data[item.field]}
          onChange={onChange}
        />
      ))}
    </div>
  )
}

// 5. Referrals Section
const ReferralsSection = ({ editabled, data, onSave, updateArDetail }) => {
  const [editedData, setEditedData] = useState(
    data.map((item) => ({ ...item, editing: false }))
  )

  const isEditing = useMemo(() => some(editedData, { editing: true }), [
    editedData
  ])

  const handleChange = useCallback(
    (index, newReferral) => {
      const _data = [...editedData]
      _data[index] = newReferral
      setEditedData(_data)
    },
    [editedData]
  )

  const handleAddMore = useCallback(() => {
    const newReferral = { editing: true }
    for (let key in FormFields) {
      newReferral[FormFields[key]] = ''
    }
    setEditedData((data) => [...data, newReferral])
  }, [])

  const handleCancel = useCallback(
    (index) => {
      const _editedData = [...editedData]
      if (_editedData[index].id) {
        _editedData[index] = { ...data[index], editing: false }
      } else {
        _editedData.splice(index, 1)
      }
      setEditedData(_editedData)
    },
    [data, editedData]
  )

  const handleUpdateWrapperImage = useCallback(
    (index, imageObj) => {
      const _data = [...data]
      _data[index] = { ..._data[index], ...imageObj }
      updateArDetail(_data)
    },
    [data, updateArDetail]
  )

  return (
    <div className="referrals-section">
      <div className="top-section">
        <div className="subtitle">Referrals</div>
        {editabled && (
          <Button
            className="add-btn"
            disabled={isEditing}
            onClick={handleAddMore}
          >
            <PlusOutlined />
            ADD
          </Button>
        )}
      </div>
      <div className="bottom-section">
        {editedData.map((item, index) => (
          <ReferralItem
            key={index}
            index={index}
            editabled={editabled}
            data={item}
            onChange={handleChange}
            onSave={onSave}
            onCancel={handleCancel}
            updateWrapperImage={handleUpdateWrapperImage}
          />
        ))}
      </div>
      {/* <div className='add-more-section'>
        <Button className='add-more-btn' type='text' onClick={handleAddMore}>
          + ADD MORE
        </Button>
      </div> */}
    </div>
  )
}

// Add helper function for markdown conversion
const convertMarkdownToBold = (text) => {
  if (!text) return '';
  return text.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
};

export default function RecommendationSection({
  editabled,
  arDetail,
  onUpdateNotes,
  onUpdateReferral,
  updateArDetail,
  view,
  hideSection,
  hideSectionHandle,
  updateEditingCount,
  person,
  lsd,
  hsd,
  exerciseRecommendationPlots,
  copilotDashboard
}) {
  const { notes, referrals, detail } = arDetail
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const lifestyleScore = _.get(lsd, 'lifestyleScore', {})
  const goals = _.get(lsd, 'goals', {})

  // Add these state declarations
  const [weeklySchedule, setWeeklySchedule] = useState(
    exerciseRecommendationPlots && 
    exerciseRecommendationPlots.weekly_schedule && 
    Object.keys(exerciseRecommendationPlots.weekly_schedule).length > 0 
      ? exerciseRecommendationPlots.weekly_schedule 
      : null
  );

  const [hsdByIntensity, setHsdByIntensity] = useState(
    exerciseRecommendationPlots &&
    exerciseRecommendationPlots.hsd_intensity &&
    Object.keys(exerciseRecommendationPlots.hsd_intensity).length > 0
      ? exerciseRecommendationPlots.hsd_intensity 
      : null
  );

  // Add useEffect to update state when props change
  useEffect(() => {
    if (exerciseRecommendationPlots) {
      setWeeklySchedule(
        exerciseRecommendationPlots.weekly_schedule && 
        Object.keys(exerciseRecommendationPlots.weekly_schedule).length > 0
          ? exerciseRecommendationPlots.weekly_schedule
          : null
      );
      setHsdByIntensity(
        exerciseRecommendationPlots.hsd_intensity &&
        Object.keys(exerciseRecommendationPlots.hsd_intensity).length > 0
          ? exerciseRecommendationPlots.hsd_intensity
          : null
      );
    }
  }, [exerciseRecommendationPlots]);

  const handleModalClose = useCallback(() => {
    if (!isUpdating) {
      setIsModalOpen(false);
    }
  }, [isUpdating]);

  const getData = useCallback(
    (param) => {
      const getValue = (pillar) => {
        // First check notes for any field
        const note = find(notes, { pillar })
        if (note && note.memo) {
          return convertMarkdownToBold(note.memo)
        }
        
        // If no note exists or is empty, fall back to detail for special fields
        if (pillar === 'intro' && detail && detail.intro) {
          return convertMarkdownToBold(detail.intro)
        }
        if (pillar === 'expectations' && detail && detail.expectations) {
          return convertMarkdownToBold(detail.expectations)
        }
        if (pillar === 'support' && detail && detail.support) {
          return convertMarkdownToBold(detail.support)
        }
        
        // If neither exists, return empty string
        return ''
      }
      
      if (isArray(param)) {
        const _data = {}
        param.forEach((pillar) => {
          _data[pillar] = getValue(pillar)
        })
        return _data
      }
      return getValue(param)
    },
    [notes, detail]
  )

  const handleUpdateArDetail = useCallback(
    (referrals) => {
      updateArDetail({ ...arDetail, referrals })
    },
    [arDetail, updateArDetail]
  )

  // Add isSectionHidden helper function
  const isSectionHidden = useCallback((sectionName) => {
    return hideSection.includes(sectionName);
  }, [hideSection]);

  // Helper function to render the HSD Chart
  const renderHSDChart = () => {
    if (!hsdByIntensity) return null;

    const domains = [
      'aerobic_fitness',
      'balance',
      'bone',
      'movement_quality',
      'body_composition',
      'cognitive_health',
      'muscular_fitness',
    ];

    // Filter out hidden intensity types
    const visibleIntensities = {
      Light: !isSectionHidden('Exercise Schedule - Light Week'),
      Moderate: !isSectionHidden('Exercise Schedule - Moderate Week'),
      Vigorous: !isSectionHidden('Exercise Schedule - Vigorous Week'),
    };

    // Create data array only including visible intensities
    const data = domains.map(domain => {
      const dataPoint = {
        name: domain.split('_').map(word => 
          word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' '),
      };

      if (visibleIntensities.Light) {
        dataPoint.Light = hsdByIntensity.light[domain] || 0;
      }
      if (visibleIntensities.Moderate) {
        dataPoint.Moderate = hsdByIntensity.moderate[domain] || 0;
      }
      if (visibleIntensities.Vigorous) {
        dataPoint.Vigorous = hsdByIntensity.vigorous[domain] || 0;
      }

      return dataPoint;
    });

    // Get visible bars for the chart
    const visibleBars = Object.entries(visibleIntensities)
      .filter(([_, isVisible]) => isVisible)
      .map(([intensity, _]) => ({
        dataKey: intensity,
        fill: intensity === 'Light' ? emerald : 
              intensity === 'Moderate' ? teal : indigo
      }));

    return (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            margin={{
              top: 20,
              right: 20,
              left: 0,
              bottom: 20
            }}
            barSize={40}
            barGap={4}
            barCategoryGap={40}
            background={{ fill: 'transparent' }}
          >
            <CartesianGrid strokeDasharray="3 3" horizontal={false} />
            <XAxis 
              type="number"
              domain={[0, 300]}
              ticks={[0, 50, 100, 150, 200, 250, 300]}
              tickMargin={8}
              scale="linear"
              padding={{ left: 0, right: 0 }}
            />
            <YAxis 
              type="category"
              dataKey="name"
              tick={{ fontSize: 13 }}
              width={140}
              padding={{ top: 15, bottom: 15 }}
            />
            <Tooltip />
            <Legend 
              wrapperStyle={{ 
                position: 'absolute',
                bottom: 0,
                left: 25,
                width: '90%',
                lineHeight: '16px'
              }} 
            />
            {visibleBars.map((bar, index) => (
              <Bar 
                key={bar.dataKey} 
                dataKey={bar.dataKey} 
                fill={bar.fill}
                barSize={40}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
    );
  };

  return (
    <RecommendationContainer>
      {/* 1. Banner Section */}
      <BannerSection />
      {/* 2. Highest Priorities */}
      <HighestPrioritiesSection
        editabled={editabled}
        data={getData(HighestPrioritiesConfigs.map(({ field }) => field))}
        onChange={onUpdateNotes}
      />
      {/* 3. Exercise Scheduler*/}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
        <Button 
          type="primary"
          onClick={() => setIsModalOpen(true)}
        >
          Open Exercise Scheduler
        </Button>
      </div>

      {/* Replace the old weekly schedule display with the new grid container */}
      <ExerciseGridContainer showHsdChart={!isSectionHidden('HSD Intensity Chart')}>
        {/* Left side: HSD Chart */}
        <HideWrap
          name="HSD Intensity Chart"
          title="HSD Intensity Chart"
          syncStatus={(name, status) => hideSectionHandle(name, status)}
          status={hideSection || []}
          view={view}
          isHealthRisk={true}
          style={{ height: '100%', display: 'flex', flexDirection: 'column', paddingTop: '120px' }}
        >
          <ChartContainer>
            {renderHSDChart()}
          </ChartContainer>
        </HideWrap>

        {/* Right side: Weekly Schedules */}
        <SchedulesContainer>
          <HideWrap
            name="Exercise Schedule - Light Week"
            title="Light Week Schedule"
            syncStatus={(name, status) => hideSectionHandle(name, status)}
            status={hideSection || []}
            view={view}
            isHealthRisk={true}
          >
            <div>
              {renderWeeklySchedule(weeklySchedule, 'light')}
            </div>
          </HideWrap>
          <HideWrap
            name="Exercise Schedule - Moderate Week"
            title="Moderate Week Schedule"
            syncStatus={(name, status) => hideSectionHandle(name, status)}
            status={hideSection || []}
            view={view}
            isHealthRisk={true}
          >
            <div>
              {renderWeeklySchedule(weeklySchedule, 'moderate')}
            </div>
          </HideWrap>
          <HideWrap
            name="Exercise Schedule - Vigorous Week"
            title="Vigorous Week Schedule"
            syncStatus={(name, status) => hideSectionHandle(name, status)}
            status={hideSection || []}
            view={view}
            isHealthRisk={true}
          >
            <div>
              {renderWeeklySchedule(weeklySchedule, 'vigorous')}
            </div>
          </HideWrap>
        </SchedulesContainer>
      </ExerciseGridContainer>

      <StepsSection
        editabled={editabled}
        data={getData(StepsConfigs.map(({ field }) => field))}
        onChange={onUpdateNotes}
      />

      <ExpectationAndNextSteps
        editabled={editabled}
        data={getData(expectationAndNextStepsConfigs.map(({ field }) => field))}
        onChange={onUpdateNotes}
      />

      <ReferralsSection
        editabled={editabled}
        data={referrals}
        onSave={onUpdateReferral}
        updateArDetail={handleUpdateArDetail}
      />
      <ResourceSection
        view={view}
        hideSection={hideSection}
        hideSectionHandle={hideSectionHandle}
      />

      {/* Modal */}
      <Modal
        open={isModalOpen}
        onCancel={handleModalClose}
        width="95%"
        footer={null}
        destroyOnClose={false}
      >
        {isModalOpen && (
          <ExerciseScheduler
            onCloseModal={() => setIsModalOpen(false)}
            onSubmit={async (data) => {
              setIsUpdating(true);
              try {
                setWeeklySchedule(data.weekly_schedule);
                setHsdByIntensity(data.hsd_intensity);
                setIsModalOpen(false);
              } finally {
                setIsUpdating(false);
              }
            }}
            goals={goals}
            lifestyleScore={lifestyleScore}
            hsd={hsd}
            initialWeeklySchedule={weeklySchedule}
            initialHsdIntensity={hsdByIntensity}
            copilotDashboard={copilotDashboard}
            person={person}
            arDetail={arDetail}
          />
        )}
      </Modal>
    </RecommendationContainer>
  )
}
